import { BaseEnum, BaseEnumItem } from './baseEnum';

const MANAGE_TYPE = new BaseEnum();
MANAGE_TYPE.set('DISTRIBUTION', new BaseEnumItem('1', '经销'));
MANAGE_TYPE.set('JOINTVENTURE', new BaseEnumItem('2', '联营'));

export { MANAGE_TYPE };